import { Component, Input, TemplateRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationDirective } from '@shared/components/translata-modal/translation.directive';
import { InfoCardComponent } from '@shared/components/info-card/info-card.component';
import { CommonModule, NgIf } from '@angular/common';

@Component({
  selector: 'app-geschaeftskonto',
  imports: [TranslationDirective, TranslateModule, InfoCardComponent, CommonModule],
  templateUrl: './geschaeftskonto.component.html',
  styleUrl: './geschaeftskonto.component.scss',
})
export class GeschaeftskontoComponent {
  @Input() infoText: TemplateRef<any>;
  @Input() kontofuehrungsgebuehr: any;
}
